(function () {
  var dataElement = document.getElementById('klaviyo-viewed-product-data');
  if (!dataElement) return;

  var data;
  try {
    data = JSON.parse(dataElement.textContent);
  } catch (error) {
    return;
  }

  var item = data.item;
  window.item = item;

  var metadata = { Brand: item.Brand, Price: item.Price, Value: item.Value };
  if (item.CompareAtPrice) metadata.CompareAtPrice = item.CompareAtPrice;

  var learnq = (window._learnq = window._learnq || []);
  learnq.push(['track', 'Viewed Product', item]);
  learnq.push([
    'trackViewedItem',
    {
      Title: item.Name,
      ItemId: item.ProductID,
      Categories: item.Categories,
      ImageUrl: item.ImageURL,
      Url: item.URL,
      Metadata: metadata,
      metafields: { reviews: data.reviews },
    },
  ]);
})();
